var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import withDesign from '../../../hocs/withDesign';
import { Translation } from '../Translation';
import { Typography } from '../Typography';
export * from './TranslatedText.types';
export var TranslatedTextComponent = function (_a) {
    var design = _a.design, schema = _a.schema, values = _a.values, watchedValues = _a.watchedValues, i18n = _a.i18n, 
    // remove from props
    components = _a.components, scale = _a.scale, actions = _a.actions, props = __rest(_a, ["design", "schema", "values", "watchedValues", "i18n", "components", "scale", "actions"]);
    return (_jsx(Typography, __assign({ "data-design": design, schema: schema }, props, { children: _jsx(Translation, __assign({}, i18n, { values: __assign(__assign({}, values), watchedValues) })) })));
};
export var TranslatedText = withDesign(TranslatedTextComponent);
TranslatedText.displayName = 'TranslatedText';
